// src/components/ImageLightbox/ImageLightbox.js
import React from 'react';
import { Modal } from 'react-bootstrap';
import './ImageLightbox.css';

const ImageLightbox = ({ show, onHide, src, title }) => {
	const isPdf = src?.toLowerCase().endsWith('.pdf');

	return (
		<Modal show={show} onHide={onHide} centered size="lg" className="image-lightbox">
			<Modal.Header closeButton>
				<Modal.Title>{title || 'Ver imagen'}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center p-0">
				{isPdf ? (
					<div className="pdf-preview p-4">
						<p className="mb-3">Este archivo es un PDF</p>
						<a href={src} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
							<i className="fa fa-external-link me-2"></i>
							Abrir PDF en nueva pestaña
						</a>
					</div>
				) : (
					<img src={src} alt={title} className="lightbox-image" />
				)}
			</Modal.Body>
		</Modal>
	);
};

export default ImageLightbox;
